/**
 *
 * v.1.0  06/03/2020  Inicial
 * v.1.1  26/06/2020  Añadido soporte para camposTexto de multiples campos con formato campo_1|..|campo_n
 * v.1.2  02/07/2020  En el construcotr, al asignar los items, llamamos a modificarItemsDesdeMarcados.
 * v.1.3  05/08/2020  En la funcion CalcularTexto, usamos getValorPropiedad para obtener las partes para componer la cadena a mostrar
 * v.2.0  30/09/2020 Cambiado a framework2
 * v.2.1  09/10/2020 Añadido ComponentDidUpdate para poder usar this.
 * v.2.2  20/10/2020 Añadida propiedad estilo.
 *                   Añadida propiedad mostrarBotones
 * v.2.3  13/11/2020 Añadida propiedad valoresTitulo
 *                   Creado método renderItemEdit y renderItem y modificación de render para llamarlos en según cada caso.
 * v.2.4  12/11/2020 En renderItemEdit, añadimos la condición de !valoresTitulo para mostrar el edit.
 * v.2.5  19/12/2020 Añadidas las propiedades anchoCheck y anchoValor.
 *                   Modificado renderITem y renderItemEdit para usar las propiedades anteriores.
 *
 * v.2.6  06/05/2022 Fusion Planifikator y Sidemur
 * v.2.7  07/07/2022 Añadido desplazamiento en los items en función del nivel
 *                   Añadida propiedad: desplazamientoNivel
 * v.2.8  28/02/2023 En marcadosChanged, cuando se desmarca, eliminamos el valor del hash de valores.
 * V.2.9  26/03/2023 En marcadosChanged, se devuelve también la lista de campos texto.
 * v.2.10 13/04/2023 Añadidas las propiedades anchoCombo, combosTitulo, onCombosChanged, onGetComboItems y toda su gestión.
 *                   Corregido changeItemValor para que cree una copa del objeto y lo meta en el state.
 **/

import React from 'react'
import PropTypes from 'prop-types';
import {Checkbox, Icon, Button, InputGroup, FormGroup} from "@blueprintjs/core";
import {posPrimerElementoConValorPropiedad} from "../utils/ArrayUtils"
import {getValorPropiedad} from "../utils/ObjectUtils";
import ComboBox from "../../blueprint/ComboBox";

class ListaChecks extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            items: props.marcadosIniciales ?
                        this.modificarItemsDesdeMarcados(props.items, props.marcadosIniciales) :  props.items,
            marcadosIniciales: props.marcadosIniciales,
            valores: {},
            valoresObjetosCombo: {},
        }
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        const {items, marcadosIniciales} = this.state;
        //console.log(" ++++ componentDidUpdate");
        if (prevState.marcadosIniciales !== marcadosIniciales && items) {
            //console.log("marcadosiniciales modificados: ", marcadosIniciales);
            let newItems = this.modificarItemsDesdeMarcados(items, marcadosIniciales);
            this.setState({items: newItems});
        }
    }


    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState) {
        //console.log(" ++++ getDerivedStateFromProps");
        const newState = {};
        if (nextProps.items !== prevState.items) {
            newState.items = nextProps.items;
        }
        if (nextProps.marcadosIniciales && nextProps.marcadosIniciales !== prevState.marcadosIniciales) {
            //console.log("marcadosiniciales modificados: ", nextProps.marcadosIniciales);
            newState.marcadosIniciales = nextProps.marcadosIniciales;
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }


    modificarItemsDesdeMarcados = (items, marcados) => {
        /*
        console.log("^..^ modificarItemsDesdeMarcados: ^..^");
        console.log("items: ", items);
        console.log("marcados: ", marcados);
         */
        const {campoId, valoresTitulo} = this.props;
        let newItems = items.slice();
        newItems.forEach( (item) => {
            console.log("item[campoId]: ", item[campoId]);
            console.log("marcados.includes(item[campoId]): ", marcados.includes(item[campoId]));
            item.marcado= marcados.includes(item[campoId]);
        });
        return newItems;
    }

    marcadosChanged = () => {
        const {items, valores} = this.state;
        const {campoId, campoTexto, onMarcadosChanged} = this.props;

        /*
        console.log("---------------- marcadosChanged: ");
        console.log("items: ", items);
        console.log("campoTexto: ", campoTexto);
        console.log("onMarcadosChanged: ", onMarcadosChanged);
        */

        if (onMarcadosChanged) {
            let newMarcados = [];
            let newMarcadosTextos= [];
            items.forEach((item) => {
                if (item.marcado && Boolean(item.marcado)) {
                    newMarcados.push(item[campoId]);
                    newMarcadosTextos.push(item[campoTexto]);
                }
                else{
                    let id= item[campoId];
                    delete valores[id];
                }
            });
            onMarcadosChanged(newMarcados, newMarcadosTextos);
        }

        //console.log("valores: ", valores);
    }

    asignarMarcado = (marcado, id) => {
        const {items} = this.state;
        const {campoId, onMarcadosChanged, onMarcadoChanged} = this.props;

        /*
        console.log("AsignarMarcado");
        console.log("marcado: ", marcado);
        console.log("id: ", id);
        */

        let posItem= posPrimerElementoConValorPropiedad(items, campoId, id);
        //console.log("posItem: ", posItem);
        if (posItem >= 0){
            let newItems= items.slice();
            //console.log("newItems: ", newItems);
            newItems[posItem].marcado= marcado;
            this.setState({items : newItems}, () => {
                onMarcadoChanged && onMarcadoChanged( newItems[posItem][campoId], marcado);
                this.marcadosChanged();
            });
        }
    }

    asignarTodosMarcados = (marcado) => {
        const {items} = this.state;
        let newItems= items.slice();
        newItems.forEach ((item) => {
            item.marcado= marcado;
        });
        this.setState({items: newItems}, () => {
            this.marcadosChanged();
        });
    }

    calcularTexto= (campoTexto, item) => {
        let titulo= "";
        if (campoTexto.includes("|")){
            let campos= campoTexto.split("|");
            campos.forEach( (campo, index) => {
                let subTexto= getValorPropiedad(item, campo.trim());
                //let subTexto= item[campo.trim()];
                if (titulo !== "")
                    titulo += " - ";
                titulo += subTexto;
            });
        }
        else{
            titulo= item[campoTexto];
        }
        return titulo;
    }

    changeItemValor= (index, newValor) => {
        const {campoId, onValoresChanged} = this.props;
        const {items, valores} = this.state;

        let id= items[index][campoId];
        let newValores= {...valores};
        newValores[id] = newValor;
        this.setState({valores: newValores});

        onValoresChanged && onValoresChanged(newValores);
    }


    changeComboValor= (index, newValorCombo) => {
        const {campoId, onCombosChanged} = this.props;
        const {items, valoresObjetosCombo} = this.state;

        let id= items[index][campoId];
        let newValoresObjetosCombo= {...valoresObjetosCombo};
        newValoresObjetosCombo[id] = newValorCombo;
        this.setState({valoresObjetosCombo: newValoresObjetosCombo});

        onCombosChanged && onCombosChanged( this.transformarValoresObjetosComboEnValoresCombo(newValoresObjetosCombo) );
    }

    transformarValoresObjetosComboEnValoresCombo= (valoresObjetosCombo) => {
        let valoresCombo= {};
        Object.keys(valoresObjetosCombo).forEach( (clave) => {
            let valor= valoresObjetosCombo[clave];
            valoresCombo[clave]= valor.codigo;
            }
        );
        return valoresCombo;
    }

    renderItemEdit= (item, valor, valorCombo, index) => {
        const {campoTexto, campoId, valoresTitulo, valoresSufijo,
            anchoCheck, anchoValor, anchoCombo, desplazamintoNivel,
            combosTitulo, itemsCombo, onGetComboItems} = this.props;

        //console.log("%%%%%% renderItemEdit: ");
        //console.log("item: ", item);
        //console.log("valor: ", valor);
        //console.log("campoId: ", campoId);
        //console.log("item[campoId]: ", item[campoId]);
        //console.log("combosTitulo: ", combosTitulo);

        let anchoCheckReal= anchoCheck ? anchoCheck : '200px';
        let anchoValorReal= anchoValor ? anchoValor : '100px';
        let marginLeft= 10 + item.nivel * desplazamintoNivel;
        let marginTop= item.nivel == 0 ? 30 : 10;
        //let backgroundColor= index % 2 == 1 ? "#eeeeee" : "#ffffff";
        let backgroundColor= item.nivel== 0 ? "#eeeeee" : "#ffffff";

        let itemsComboReal = itemsCombo ? itemsCombo : onGetComboItems && onGetComboItems(item);
        let anchoComboReal= anchoCombo ? anchoCombo : '300px';
        let itemComboSelected= valorCombo ? valorCombo : null
        //console.log("itemComboSelected: ", itemComboSelected);

        //console.log("itemsComboReal: ", itemsComboReal);

        return (
            <div style={{display: 'flex',  marginTop: marginTop, marginLeft: marginLeft, alignItems: 'center', backgroundColor: backgroundColor}} key={`d${index}`}>
                <Checkbox style={{margin: '4px', width: anchoCheckReal}} key={index}
                          checked={item.marcado ? item.marcado : false}
                          onClick={(event) => this.asignarMarcado(event.target.checked, item[campoId])}>
                    {this.calcularTexto(campoTexto, item)}
                </Checkbox>
                {(item.marcado && valoresTitulo) &&
                <>
                    <InputGroup
                        style={{marginLeft: 20, width: anchoValorReal}}
                        placeholder={valoresTitulo}
                        value={valor}
                        onChange={(event) => this.changeItemValor(index, event.target.value)}
                    />
                    <div style={{marginLeft: 4}}> {valoresSufijo} </div>
                </>
                }

                {(item.marcado && combosTitulo) &&
                <>
                    <div style={{marginLeft: 20, width: anchoComboReal}}>
                        <ComboBox
                            id= "cbe"
                            fieldText="nombre"
                            fieldKey="codigo"
                            items={itemsComboReal}
                            onValueChanged={(objeto) => this.changeComboValor(index, objeto)}
                            placeholder= "Recurso.."
                            filterable={false}
                            popoverClassName="popover"
                            itemSelected= {valorCombo ? valorCombo : null}
                        />
                    </div>
                </>
                }
            </div>
        );
    }


    llamadaRenderItem= (item, index) => {
        const {valores, valoresObjetosCombo} = this.state;
        const {campoId,  valoresTitulo, combosTitulo} = this.props;

        let valor = null;
        let valorCombo = null;
        if (valoresTitulo) {
            let id = item[campoId];
            valor = valores[id];
        }
        if (combosTitulo){
            let id = item[campoId];
            valorCombo = valoresObjetosCombo[id];
        }
        return this.renderItemEdit(item, valor, valorCombo, index);
    }

    render() {
        const {items, valores} = this.state;
        const {titulo, campoTexto, campoId, estilo, mostrarBotones, valoresTitulo} = this.props;
        let estiloReal= estilo ? estilo : {marginLeft:'10px', width: '80%'};
        let mostrarBotonesReal= mostrarBotones == undefined || Boolean(mostrarBotones);

        //console.log("LISTA CHECKS RENDER");


        return (
            <>
                {items &&
                <div style={estiloReal}>
                    <div style={{fontSize: '1.2em'}}>{titulo}</div>
                    <div style={{ width: '95%', textAlign: 'left', margin: 'auto'}}>
                        {items.map((item, index) => {
                            return this.llamadaRenderItem(item, index);
                            })
                        }
                    </div>
                    {mostrarBotonesReal &&
                    <div style={{padding: '4px'}}>
                        <Button style={{margin: '2px'}} onClick={() => this.asignarTodosMarcados(true)}>Seleccionar
                            todos</Button>
                        <Button style={{margin: '2px'}} onClick={() => this.asignarTodosMarcados(false)}>Deseleccionar
                            todos</Button>
                    </div>
                    }
                </div>
                }
            </>
        );
    }
}


ListaChecks.propTypes = {
    titulo: PropTypes.string,
    items: PropTypes.array.isRequired,
    marcadosIniciales: PropTypes.array.isRequired,
    campoTexto: PropTypes.string,
    campoId: PropTypes.string,
    onMarcadosChanged: PropTypes.func,
    onMarcadoChanged: PropTypes.func,
    estilo: PropTypes.object,
    mostrarBotones: PropTypes.bool,
    valoresTitulo: PropTypes.string,
    onValoresChanged: PropTypes.func,
    mostrarEdit: PropTypes.bool,
    anchoCheck: PropTypes.any,
    anchoValor:PropTypes.any,
    desplazamintoNivel: PropTypes.number, //En pixels

    anchoCombo: PropTypes.any,
    combosTitulo: PropTypes.string,
    onCombosChanged: PropTypes.func,
    onGetComboItems: PropTypes.func,
}


export default ListaChecks